<template>
  <div class="custom-locale-control-feature-edit-container">
    <el-input v-model="text"
      size="small"
      @keyup.enter="textEnter"
      @change="toElIndexClear"
    ></el-input>
    <el-scrollbar max-height="12.5rem" ref="scrollbarRef">
      <div class="custom-locale-control-feature-edit-row"
        v-for="(feature, index) of featureList"
        :key="index"
        @click="featureAdd(feature)"
        :style="{
          background: feature[checkProp]?'var(--backgroundColor_36)':'var(--backgroundColor_16)',
          color: feature[checkProp]?'var(--fontColor_8)':'',
        }"
        ref="featureRow"
      >
        <div class="row-edit row-div" v-show="!feature[viewShowProp]">
          <el-input v-model="feature.name" size="small" class="row-content"></el-input>
          <svg-icon iconName="check-box" fillColor="rgb(46, 206, 108)"
            @click.stop="checkClick(feature)"
          ></svg-icon>
        </div>
        <div class="row-view row-div" v-show="feature[viewShowProp]">
          <div class="row-content row-view">
            {{ feature.name }}
          </div>
          <svg-icon iconName="edit-box" fillColor="rgb(6, 180, 221)"
            @click.stop="editClick(feature)"
          ></svg-icon>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import SvgIcon from '@/components/SvgIcon';

import { queryRegionFeatureList } from '@/api/UserWorkspaceDataApi';

// props
const props = defineProps({
  features: { type: Array, default: ()=> [] },
  featureList: { type: Array, default: ()=> [] },
});
// emit
const emit = defineEmits([
  'featureInit', 'featureChangeFnInit', 'scrollbarRefChange',
]);
const scrollbarRef = ref();

const featureRow = ref(), featureRows = computed(()=>{
  return Array.from(featureRow.value || []);
})
let toElIndex, toElIndexClear = ()=>{ toElIndex = undefined; };
const text = ref(''),
      textEnter = ()=>{
        const val = text.value;
        const startIndex = (toElIndex!=undefined)?parseInt(toElIndex)+1:0;
        const list = featureRows.value.slice(startIndex);
        for(const index in list){
          const el = list[index];
          const contentEl = el.querySelector('.row-content.row-view'),
                content = contentEl.innerHTML;
          if(content.includes(val)){
            el.scrollIntoView && el.scrollIntoView();
            toElIndex = parseInt(startIndex)+parseInt(index);
            toElIndex+1>=featureRows.value.length && (toElIndex = 0);
            break;
          }
          if(list.length - 1 == index){
            toElIndexClear();
          }
        }
      }

const featuresInit = ()=>{
  props.features.forEach(item=>{
    item[viewShowProp.value] = true;
  })
}

const viewShowProp = ref('viewShow'), checkProp = ref('isCheck');
const checkClick = (feature)=>{
  feature[viewShowProp.value] = true;
}
const editClick = (feature)=>{
  feature[viewShowProp.value] = false;
}

const featureAdd = (feature)=>{
  if(!feature[viewShowProp.value])return;
  feature[checkProp.value] = !feature[checkProp.value];
  // if(props.target[props.featureProp].includes(feature.name)){
  //   props.target[props.featureProp].splice(
  //     props.target[props.featureProp].findIndex((str)=>{
  //       return str == feature.name;
  //     }), 1
  //   );
  // }else{
  //   props.target[props.featureProp].push(feature.name);
  // }
}

const queryRegionFeatureListInit = ()=>{
  const checkList = props.featureList.filter(e=> e[checkProp.value]).map(e=> e.regionFeatureId);
  let list = [];
  queryRegionFeatureList({}).then(res=>{
    if(res.data.code == 1004){
      list = res.data.dataList.map(e=>{
        return {
          ...e,
          [checkProp.value]: props.features.map(f=> f.regionFeatureId ).includes(e['regionFeatureId'])
            || checkList.includes(e['regionFeatureId']),
          [viewShowProp.value]: true,
        }
      });
    }
    emit('featureInit', list);
  }).catch(err=>{
    emit('featureInit', list);
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  featuresInit();
  queryRegionFeatureListInit();
  emit('scrollbarRefChange', scrollbarRef.value);
  emit('featureChangeFnInit', queryRegionFeatureListInit);
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  
});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.custom-locale-control-feature-edit-container{
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 120px;
  .custom-locale-control-feature-edit-row{
    --rowHeight: 24px;
    border-radius: var(--borderRadiusSize_4);
    padding: 0 5px;
    .row-div{
      height: var(--rowHeight);
      display: flex;
      align-items: center;
      gap: 5px;
      // padding: 5px;
      .el-input{
        height: calc(var(--rowHeight) - 4px);
        line-height: calc(var(--rowHeight) - 4px);
      }
      .row-content{
        min-width: 0;
        flex: 1;
      }
      .row-view{
        font-size: 12px;
      }
      .svg-icon{
        height: var(--rowHeight);
        width: var(--rowHeight);
      }
    }
  }
}
</style>